// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealDocResolver } from '@services/resolvers/deal-doc.resolver';
import { DealResolver } from '@services/resolvers/deal.resolver';
import { DealComponent } from '../deal/deal.component';

const routes: Routes = [
    {
        path: '',
        component: DealComponent,
        resolve: {
            deal: DealResolver,
            documents: DealDocResolver,
        },
    },
    {
        path: 'add',
        loadChildren: () => import('./dealer-deal-add-doc-routing.module').then((m) => m.DealerDealAddDocRoutingModule),
    },
    {
        path: 'merge',
        loadChildren: () => import('./dealer-merged-pdf-routing.module').then((m) => m.DealerMergedPdfRoutingModule),
        resolve: {
            dealDocs: DealDocResolver,
        },
    },
    {
        path: 'notarize',
        loadChildren: () => import('./dealer-notarize-routing.module').then((m) => m.DealerNotarizeRoutingModule),
        resolve: {
            deal: DealResolver,
            dealDocs: DealDocResolver,
        },
    },
    {
        path: 'send',
        loadChildren: () => import('./dealer-send-docs.module').then((m) => m.DealerSendDocsModule),
    },
    {
        path: ':docId',
        loadChildren: () => import('../../deal-docs-container/dealer-doc-routing.module').then((m) => m.DealerDocRoutingModule),
        resolve: {
            deal: DealResolver,
            documents: DealDocResolver,
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DealerDealRoutingModule {}
